import { FC } from 'react'

const LockUserCircle: FC<React.SVGProps<SVGSVGElement>> = ({
  className,
  fill,
  height,
  width,
  ...rest
}) => {
  return (
    <svg
      className={className}
      width={width || '24'}
      height={height || '24'}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <circle cx='12' cy='12' r='11' fill={fill || '#D70015'} />
      <path
        d='M15.5789 10.8182C16.0579 10.8182 16.5163 10.8864 16.9474 11.0159V10.1364C16.9474 9.38636 16.3316 8.77273 15.5789 8.77273H14.8947V7.40909C14.8947 5.52727 13.3621 4 11.4737 4C9.58526 4 8.05263 5.52727 8.05263 7.40909V8.77273H7.36842C6.61579 8.77273 6 9.38636 6 10.1364V16.9545C6 17.7045 6.61579 18.3182 7.36842 18.3182H11.6516C11.1111 17.5477 10.7895 16.6068 10.7895 15.5909C10.7895 12.9523 12.9311 10.8182 15.5789 10.8182ZM9.35263 7.40909C9.35263 6.24318 10.3037 5.29545 11.4737 5.29545C12.6437 5.29545 13.5947 6.24318 13.5947 7.40909V8.77273H9.35263V7.40909Z'
        fill='white'
      />
      <path
        d='M15.5789 12.1818C13.6905 12.1818 12.1579 13.7091 12.1579 15.5909C12.1579 17.4727 13.6905 19 15.5789 19C17.4674 19 19 17.4727 19 15.5909C19 13.7091 17.4674 12.1818 15.5789 12.1818ZM15.5789 13.5455C16.1468 13.5455 16.6053 14.0023 16.6053 14.5682C16.6053 15.1341 16.1468 15.5909 15.5789 15.5909C15.0111 15.5909 14.5526 15.1341 14.5526 14.5682C14.5526 14.0023 15.0111 13.5455 15.5789 13.5455ZM15.5789 17.6364C14.8742 17.6364 14.2516 17.2818 13.8821 16.7364C14.3816 16.45 14.9563 16.2727 15.5789 16.2727C16.2016 16.2727 16.7763 16.45 17.2758 16.7364C16.9063 17.2818 16.2837 17.6364 15.5789 17.6364Z'
        fill='white'
      />
    </svg>
  )
}

export default LockUserCircle
